/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Represent a "Min Key" type in Firestore documents.
 *
 * @class MinKey
 */
export class MinKey {
  private static MIN_KEY_VALUE_INSTANCE: MinKey | null = null;
  /** A type string to uniquely identify instances of this class. */
  readonly type = 'MinKey';

  private constructor() {}

  static instance(): MinKey {
    if (!MinKey.MIN_KEY_VALUE_INSTANCE) {
      MinKey.MIN_KEY_VALUE_INSTANCE = new MinKey();
    }
    return MinKey.MIN_KEY_VALUE_INSTANCE;
  }
}
